/* eslint-disable quotes */
export default {
  AWAY_TIME: 'h',
  COMMON__MINUTES: 'm',
  SENDBIRD: {
    BADGE__OVER: '+',
    MESSAGE_MENU__EDIT: 'Edit',
    BUTTON__DELETE: 'Delete',
    MESSAGE_STATUS__DELETE: 'Delete',
    MESSAGE_MENU__DELETE: 'Delete',
    BUTTON__SAVE: 'Save',
    BUTTON__CLOSE: 'Close',
    BUTTON__CANCEL: 'Cancel',
    CHANNEL_SETTING__PROFILE__EDIT: 'Edit',
    MESSAGE_INPUT__PLACE_HOLDER: 'Enter',
    MODAL__CHANNEL_INFORMATION__UPLOAD: 'Upload',
    EDIT_PROFILE__IMAGE_UPLOAD: 'Upload',
    CHANNEL_LIST__TITLE: 'Channel',
    MESSAGE_MENU__COPY: 'Copy',
    CHANNEL_SETTING__HEADER__TITLE: 'Channel info',
    MODAL__USER_LIST__TITLE: 'Members',
    CHANNEL_SETTING__MEMBERS__TITLE: 'Members',
    NO_MEMBERS: '(No members)',
    NO_NAME: '(No name)',
    TOOLTIP__UNKOWN_USER: '(No name)',
    CHANNEL_SETTING__LEAVE_CHANNEL__TITLE: 'Leave channel',
    BUTTON__INVITE: 'Invite',
    MODAL__INVITE_MEMBER__SELECTED: 'Selected',
    MODAL__CREATE_CHANNEL__SELECTED: 'Selected',
    MODAL__CHANNEL_INFORMATION__CHANNEL_NAME: 'Channel name',
    MODAL__INVITE_MEMBER__TITLE: 'Invite members',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER: 'Enter',
    BUTTON__CREATE: 'Create',
    MODAL__CREATE_CHANNEL__TITLE: 'New channel',
    TRYING_TO_CONNECT: 'Trying to connect...',
    USER_PROFILE__MESSAGE: 'Message',
    USER_PROFILE__USER_ID: 'User ID',
    EDIT_PROFILE__USERID_LABEL: 'User ID',
    EDIT_PROFILE__TITLE: 'My profile',
    EDIT_PROFILE__IMAGE_LABEL: 'Profile image',
    EDIT_PROFILE__NICKNAME_LABEL: 'Nickname',
    EDIT_PROFILE__THEME_LABEL: 'Dark theme',
    CHANNEL__MESSAGE_INPUT__PLACE_HOLDER__DISABLED: 'Chat is unavailable in this channel',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__NEW_MESSAGE: 'new message(s) since',
    CHANNEL__MESSAGE_LIST__NOTIFICATION__ON: 'on',
    CHANNEL_SETTING__MEMBERS__SEE_ALL_MEMBERS: 'All members',
    CHANNEL_SETTING__MEMBERS__INVITE_MEMBER: 'Invite users',
    MODAL__DELETE_MESSAGE__TITLE: 'Delete this message?',
    MODAL__CHANNEL_INFORMATION__TITLE: 'Edit channel information',
    MODAL__CHANNEL_INFORMATION__CHANNEL_IMAGE: 'Channel image',
    MODAL__CHANNEL_INFORMATION__INPUT__PLACE_HOLDER: 'Enter name',
    TYPING_INDICATOR__IS_TYPING: 'typing...',
    TYPING_INDICATOR__ARE_TYPING: 'typing...',
    TYPING_INDICATOR__MULTIPLE_TYPING: 'typing...',
    TYPING_INDICATOR__AND: 'and',
    MESSAGE_STATUS__SENDING_FAILED: "Couldn't send message.",
    MESSAGE_STATUS__TRY_AGAIN: 'Try again',
    MESSAGE_STATUS__OR: 'or',
    PLACE_HOLDER__WRONG: 'Something went wrong.',
    PLACE_HOLDER__RETRY_TO_CONNECT: 'Retry',
    NO_TITLE: 'No title',
    TOOLTIP__AND_YOU: ', and you',
    TOOLTIP__YOU: 'You',
    UNKNOWN__UNKNOWN_MESSAGE_TYPE: '(Unknown message type)',
    UNKNOWN__CANNOT_READ_MESSAGE: 'Cannot read this message.',
    MESSAGE_EDITED: '(edited)',
    PLACE_HOLDER__NO_CHANNEL: 'Start a new conversation',
    MESSAGE_MENU__REPLY: 'Reply',
    QUOTED_MESSAGE__REPLIED_TO: '→',
    QUOTE_MESSAGE_INPUT__REPLY_TO: '',
    QUOTED_MESSAGE__CURRENT_USER: 'You',
    MESSAGE_INPUT__QUOTE_REPLY__PLACE_HOLDER: 'Reply to a message',
  },
  TERMS_IMPRESSUM: 'Impressum',
  TERMS_DATENSCHUTZ: 'Datenschutz',
  CONFIRM: 'OK',
  SETTINGS__NONE: 'None',
  SEARCH__NO_RESULT: 'No results found',
  LOGIN__PASSWORD: 'Password',
  SEARCH__USER_PLACEHOLDER: 'Name/Employee No./Phone No.',
  BASIC__: {
    HAS_ATTENDANCE_HISTORY_VIEW_RIGHT: 'Authority to view personal attendance history',
    ERROR: 'An error occured. <br /> Please try again later.',
    MSG__: { INPUT: 'Search by keyword' },
    PWD_ALL_VALIDATION:
      'Password must be a combination of %1$@~%2$@ upper/lowercase letters, numbers, and special characters.',
    RETRY: 'Retry',
    PASSWORD_RULE: '8-20 characters and contain letters, numbers, and symbols.',
  },
  SEARCH__NO_USER_INFO: 'No user info.',
  LOGIN__EMAIL_OR_HP: 'Email or Phone no.',
  BASIC__SEARCH: 'Search',
  ELECTRON: {
    MENU_DELETE: 'Delete',
    MENU_VIEW: 'View',
    MENU_SIGN_OUT: 'Logout',
    MENU_SETTINGS: 'Settings',
    MENU_CLOSE: 'Close',
    MENU_EDIT: 'Edit',
    MENU_SELECT_ALL: 'Select All',
    MENU_COPY: 'Copy',
    MENU_FILE: 'Files',
    MENU_ABOUT: 'About {0}',
    MENU_UPDATE: 'Check update',
    MENU_HIDE: 'Hide {0}',
    MENU_HIDE_OTHERS: 'Hide others',
    MENU_SHOW_ALL: 'Show all',
    MENU_QUIT: 'Quit {0}',
    MENU_NEW_CHANNEL: 'New channel',
    MENU_UNDO: 'Undo',
    MENU_REDO: 'Redo',
    MENU_CUT: 'Cut',
    MENU_PASTE: 'Paste',
    MENU_PASTE_AND_MATCH_STYLE: 'Paste style',
    MENU_RELOAD: 'Reload',
    MENU_FORCE_RELOAD: 'Force reload',
    MENU_FULL_SCREEN: 'Toggle full screen',
    MENU_RESET_ZOOM: 'Actual size',
    MENU_ZOOM_IN: 'Zoom in',
    MENU_ZOOM_OUT: 'Zoom out',
    MENU_WINDOW: 'Window',
    MENU_MINIMIZE: 'Minimize',
    MENU_ZOOM: 'Zoom',
    MENU_HELP: 'Help',
    MESSAGE_UP_TO_DATE: 'You are currently using the latest version.',
    UPDATE_AVAILABLE: 'Update available',
    MESSAGE_UPDATE_AVAILABLE: 'An update to the latest version is available.',
    UP_TO_DATE: 'Latest ver.',
  },
  LOGIN__INSERT_EMAIL_HP: 'Enter your email or phone no.',
  LOGIN__PASSWORD_GUIDE_SUBTITLE: 'If you forgot your password, please reset it on the mobile app login page.',
  LOGIN__INSERT_PASSWORD: 'Please enter password',
  LOGIN__PASSWORD_INFORMATION: 'Forgot your password?',
  BEFORE: 'Before',
  ALERT__NO_ONE_SELECTED: 'No one has been selected.',
  LOGOUT: 'Logout',
  LOGIN: 'Login',
  COMMON__SECONDS: 'Second(s)',
  SCHEDULE__: {
    GUIDE__: {
      IF_YOU_STOP_UNSAVED: 'If you stop editing, any unsaved changes will be lost.',
      ARE_YOU_SURE_WANT_TO_STOP: 'Are you sure you want to stop editing the schedule?',
    },
  },
  TEMPLATE__: { GUIDE__: { NO_TEMPLATE_REGISTERED: 'No template registered' } },
  SETTINGS__CHANGE_LANGUAGE: 'Language',
  SEARCH__MEMBER_PLACEHOLDER: 'Name/Employee no./Phone no.',
  MSG__: {
    BASIC__: { NO_SEARCH_RESULT: 'No results found.' },
    ERROR__: {
      CREATE_CHANNEL: "Couldn't create channel.",
      UPDATE_CHANNEL_INFO: "Couldn't update channel.",
      LEAVE_CHANNEL: "Couldn't leave channel.",
    },
    FILE__: { MAXIMGSIZE: 'File size limit exceeded.' },
    ALLOW_BROWSER_ALARM: 'Allow notifications in your browser settings to receive notification messages.',
    LABEL__: { SEARCH_MESSAGE: 'Search messages' },
    GUIDE__: {
      SEARCH_MESSAGE: 'Search for the message you want to find in {0}.',
    },
  },
  BASIC__UNKNOWN: 'Unknown',
  LOGIN__SERVER_ALERT: "Couldn't connect to server.",
  INVITE__MEMBER_SELECTION: 'Choose members',
  CHANNEL__EDIT_CHANNEL_NAME_GUIDE: 'The changed name will be visible to all channel participants.',
  NOTICE: 'Notifications',
  INVITE__CREATE: 'Create',
  CHANNEL__LEAVE_THIS_CHANNEL: 'Leave the channel?',
  LOGIN__PASSWORD_FAIL_COUNT: 'You have entered the wrong password {0} time(s).',
  LOGIN__FAIL_ALERT: 'It will be locked for 5 minutes after 5 consecutive wrong attempts.',
  LOGIN__LOCK_STATE_ALERT: 'Locked for 5 minutes due to consecutive wrong password attempts.',
  LOGIN__RETRY_ALERT: 'Please try again in {0}.',
  LOGIN__PASSWORD_GUIDE_TITLE: "ShoplChat's password is the same as the mobile app's password.",
  SETTINGS__ALL_MESSAGES: 'Notifications on all new messages',
  SETTINGS__ALARM_SOUND: 'Sound',
  SETTINGS__SOUND_ALARM: 'Notification sound',
  SETTINGS__LISTEN_ALARM_SOUND: 'Listen',
  ALERT__MAX_INVITE_MEMBER: 'Max. number of people who can join the channel is 20,000.',
  LOGIN__DEACTIVATED_ALERT: 'Unable to login since the administrator deactivated the chat feature.',
  LOGIN__SERVER_ALERT_CONTENTS:
    'Unable to login due to unstable network. Please check the network connection and try again.',
  LOGIN__LOGOUT_ALERT: 'You have been logged out.',
  CHANNEL__EDIT_CHANNEL_NAME: 'Change channel name',
  SETTINGS__THEME: 'Theme',
  SETTINGS__LANGUAGE: 'Language',
  SETTINGS__LIGHT_THEME: 'Light',
  SETTINGS__DARK_THEME: 'Dark',
  SEARCH__CHANNEL_PLACEHOLDER: 'Employee name',
  CHANNEL__CONTACT: '1:1 chat',
  BASIC: { LABEL: { MAXIMAGECNT: 'Up to {0} images can be uploaded.' } },
  LOGIN__LOGIN_FAILED: 'Incorrect ID or password.',
  FORGOT_PW: 'Forgot your password?',
  BASIC__MAX_FORMAT_INPUT: 'Max. %@ characters can be entered.',
  SERVICE__COMING_SOON: 'Coming soon',
  LOGIN__GUIDE: 'You can log in with the account used on the app.',
  MOBILE__: {
    ACCESS_PC: 'Access the dashboard from PC!',
    ACCESS_DESC_01: 'Dashboard is optimized for the PC environment.',
    ACCESS_DESC_02: 'Try access from a PC for your best experience.',
    ACCESS_PC_ONLY: 'Try access from PC!',
    GUIDE: 'The chat feature is available on your PC or mobile app.',
  },
  CHANNEL__NO_CHAT_HISTORY: 'No conversations',
};
